module.exports = __webpack_public_path__ + "img/calendar-26_fill.0d93a8a4.svg";